import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import * as fromStore from "../../../store";
import {DbStoreState} from "../../../store/reducers";
import {Store} from "@ngrx/store";
import {filter, first, switchMap} from "rxjs/operators";

@Injectable()
export class BackupDataLimitResolver implements Resolve<BackupDataLimitResolver|null> {

  constructor(
    private _store: Store<DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getBackupLimitsLoaded)
        .pipe(
          filter((loaded: boolean): boolean => loaded),
          switchMap(() => this._store.select(fromStore.getBackupLimits)),
          first()
        )
        .subscribe((backupLimits) => {
          if (backupLimits) {
            resolve(backupLimits);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
